import { LicenseInfo } from "@mui/x-license-pro";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Container, StyledEngineProvider, ThemeProvider } from "@mui/material";
import theme from "@/theme";
import App from "./App";
import { store, persistor } from "@/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./utils/i18n";
import { initAppcues } from "@/features/appcuesHelper";

declare global {
  interface Window {
    heap?: any; // Use 'any' or provide a strict Heap type if you have one
  }
}

// Appcues
initAppcues();

// Heap.io: Start capturing data
window.heap.load(import.meta.env.VITE_HEAPIO_ID);
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

const container = document.getElementById("root");
if (container) {
  const root = ReactDOM.createRoot(container);

  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <ThemeProvider theme={theme}>
            <StyledEngineProvider injectFirst>
              <Container>
                <App />
              </Container>
            </StyledEngineProvider>
          </ThemeProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
}